import React from 'react';
import { Avatar, Button, theme } from 'antd';
import { CloseOutlined, UserOutlined } from '@ant-design/icons';
import './widget-messenger.css';

export interface MessengerPanelProps {
    open: boolean;
    title: string;
    subtitle: string;
    closeLabel: string;
    ariaLabel: string;
    onClose: () => void;
    children: React.ReactNode;
}

/**
 * Intercom-style floating messenger card (fixed bottom-right, rounded, no backdrop).
 */
export const MessengerPanel: React.FC<MessengerPanelProps> = ({
    open,
    title,
    subtitle,
    closeLabel,
    ariaLabel,
    onClose,
    children,
}) => {
    const { token } = theme.useToken();

    if (!open) {
        return null;
    }

    return (
        <div
            className="support-messenger-panel"
            role="dialog"
            aria-modal="true"
            aria-label={ariaLabel}
            style={{
                background: token.colorBgContainer,
                boxShadow: token.boxShadowSecondary,
            }}
        >
            <header
                className="support-messenger-header"
                style={{
                    background: token.colorBgElevated,
                    borderBottom: `1px solid ${token.colorBorder}`,
                }}
            >
                <Avatar size={32} icon={<UserOutlined />} />
                <div className="support-messenger-header-text">
                    <span
                        className="support-messenger-header-title"
                        style={{ color: token.colorText }}
                    >
                        {title}
                    </span>
                    <span
                        className="support-messenger-header-subtitle"
                        style={{ color: token.colorTextSecondary }}
                    >
                        {subtitle}
                    </span>
                </div>
                <Button
                    type="text"
                    size="small"
                    icon={<CloseOutlined />}
                    onClick={onClose}
                    aria-label={closeLabel}
                />
            </header>
            <div className="support-messenger-body">{children}</div>
        </div>
    );
};
